import { render } from "./SendShippingListField.vue?vue&type=template&id=65a0cd71"
import script from "./SendShippingListField.vue?vue&type=script&lang=js"
export * from "./SendShippingListField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__